import { Component } from '@angular/core';

@Component({
  selector: 'app-bottom-nav',
  templateUrl: './bottom-nav.component.html',
  styleUrls: ['./bottom-nav.component.scss']
})
export class BottomNavComponent {
  navItems = [
    { label: 'Home', icon: 'pi-home', route: '/dashboard' },
    { label: 'Clubs', icon: 'pi-users', route: '/clubs' },
    { label: 'Members', icon: 'pi-user', route: '/members' },
    { label: 'More', icon: 'pi-bars', route: '/menu' }
  ];
}
